<div class="community-tabs" [class.gradient]="type() === 'gradient'" [class.solid]="type() === 'solid'">
  <div class="community-tabs__tablist">
    @for (tab of tabs(); track tab.title) {
      @let isActiveTab = tab.id === selectedTab()?.id;

      <button class="community-tabs__tab" [class.active]="isActiveTab" (click)="selectTab(tab)">
        <div class="tab-container" [class.active]="isActiveTab" [@tabAnimation]="getTabState(isActiveTab)">
          <span class="community-tabs__tab-title" [class.active]="isActiveTab">{{ tab.title }}</span>
          <div class="community-tabs__selection-indicator" [class.active]="isActiveTab"></div>
        </div>
      </button>
    }
  </div>
</div>
